/*
grad_height_n:
0 = fill from bottom
100 = fill to top
*/

const CompGradientBarFeedback = ({ svg_width = 20, grad_height_n = 0 }) => {
  const css_a_id =
    "a" +
    ((Date.now() + Math.random()) * Math.random())
      .toString()
      .replace(/\./g, "");
  function getColor(grad_height_n) {
    const gradient_height_color_js = {
      "100": "#00ff00",
      "90": "#d6d000",
      "80": "#d6d000",
      "70": "#d6d000",
      "60": "#d6d000",
      "50": "#d6d000",
      "40": "#d6d000",
      "30": "#ff9900",
      "20": "#ff6600",
      "10": "#ff3300",
      "0": "#ffffff"
    };
    const k = (Math.round((grad_height_n / 100) * 10, 0) * 10).toString();
    return gradient_height_color_js[k];
  }

//   function transformLog(n) {
//     let res = (Math.log10(n) * 100) / 2;
//     res = (Math.round(res / 10, 0) - 1) * 10;
//     return res;
//   }
  const color_hex = getColor(grad_height_n);
  const g = (
    <svg
      style={{ marginLeft: 4, marginRight: 4 }}
      width={svg_width}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 102"
    >
      <defs>
        <linearGradient
          id={css_a_id}
          x1={0.0}
          y1={0.0}
          x2={18}
          y2={98}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.7 - 0.0075 * grad_height_n} stopColor="#fff" />
          <stop offset={(100 - grad_height_n) / 100} stopColor={color_hex} />
        </linearGradient>
      </defs>
      <path
        stroke="grey" //{color_hex}
        strokeWidth={0.5}
        strokeMiterlimit={1}
        fill={`url(#${css_a_id})`}
        d="M0.5 0.82H19V100H0.5z"
      />
    </svg>
  );

  return g;
};

export default CompGradientBarFeedback;
